import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global error handler to catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // Check if it's a JSON parsing error
  if (event.reason && (
    event.reason.message?.includes('Unexpected token') ||
    event.reason.message?.includes('JSON') ||
    event.reason.toString().includes('Unexpected token')
  )) {
    // Prevent the default error logging
    event.preventDefault();
    console.warn('Caught unhandled promise rejection (likely API error):', event.reason.message || event.reason);
    // The error should be handled by our API interceptors, so we just suppress the console error
    return;
  }
});

// Also catch general errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('Unexpected token')) {
    // This is likely from our API calls, prevent default handling
    event.preventDefault();
    console.warn('Caught error (likely API parsing error):', event.error.message);
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
